import { Navigate, useParams } from "react-router-dom";
import { SCREENS } from "utils/constants";

const FlowRedirect = () => {
  const { id } = useParams();
  return (
    <Navigate
      to={`${SCREENS.PRIVATE.ADMIN.CANVASES.path}/${id}`}
      replace
    />
  );
};

export default FlowRedirect;
